import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/** @jsx jsx */

/* eslint react/jsx-key: 0 */


import Highlight, { defaultProps } from 'prism-react-renderer';
import { jsx, Styled } from 'theme-ui';
import { usePrismTheme } from '~utils/theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const Code = ({
  children,
  className: outerClassName
}) => {
  const [language] = outerClassName ? outerClassName.replace(/language-/, '').split(' ') : ['text'];
  const theme = usePrismTheme();
  return jsx(Highlight, _extends({}, defaultProps, {
    code: children.trim(),
    language: language,
    theme: theme
  }), ({
    className,
    style,
    tokens,
    getLineProps,
    getTokenProps
  }) => jsx(Styled.pre, {
    className: `${outerClassName || ''} ${className}`,
    style: _objectSpread(_objectSpread({}, style), {}, {
      overflowX: 'auto'
    }),
    "data-testid": "code"
  }, tokens.map((line, i) => jsx("div", getLineProps({
    line,
    key: i
  }), line.map((token, key) => jsx("span", _extends({}, getTokenProps({
    token,
    key
  }), {
    sx: {
      display: 'inline-block'
    }
  })))))));
};

if (typeof Code !== 'undefined' && Code && Code === Object(Code) && Object.isExtensible(Code) && !Code.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Code, '__filemeta', {
    configurable: true,
    value: {
      name: "Code",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Code/index.js"
    }
  });
}